import { jsx as _jsx } from "react/jsx-runtime";
import { Status } from "@chessalpha/core";
import { colors, Typography } from "@mui/material";
import { activityWalkOverTime, autoStartExtraTime } from "@ssf/play-common";
import { useEffect, useState } from "react";
import { digitalClock } from "../../index.js";
export const Clock = ({ result, status, isWithinStartRange, autoStart, toMove, timeLeft, color, timestamp, serverTimestamp, onOutOfTime, }) => {
    const [timerStart, setTimerStart] = useState(performance.now());
    const isStartAndAutoStart = status < Status.ABORTED &&
        autoStart &&
        isWithinStartRange &&
        toMove === color;
    const running = ((status === Status.STARTED && !isWithinStartRange) ||
        isStartAndAutoStart) &&
        toMove === color;
    const [currentTime, setCurrentTime] = useState(performance.now());
    const timeSpent = currentTime -
        timerStart +
        (serverTimestamp > timestamp ? serverTimestamp - timestamp : 0);
    const calcTime = status === Status.OUTOFTIME && (result ^ 24) === color
        ? 0
        : running
            ? timeLeft - timeSpent + (isStartAndAutoStart ? autoStartExtraTime : 0)
            : timeLeft;
    // biome-ignore lint/correctness/useExhaustiveDependencies: Observer
    useEffect(() => {
        const now = performance.now();
        setTimerStart(now);
        setCurrentTime(now);
    }, [isWithinStartRange, toMove]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Observer
    useEffect(() => {
        if (running && calcTime > 0) {
            const timeout = setTimeout(() => {
                setCurrentTime(performance.now());
            }, 500);
            return () => clearTimeout(timeout);
        }
    }, [currentTime, running]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Unstable dependencies
    useEffect(() => {
        if (calcTime < 0 ||
            (isStartAndAutoStart && activityWalkOverTime < timeSpent)) {
            onOutOfTime?.();
        }
    }, [calcTime]);
    return (_jsx(Typography, { sx: [
            {
                fontSize: "inherit",
                lineHeight: "inherit",
                marginLeft: "auto",
                backgroundColor: "#FFF",
                color: "#343434",
                padding: "0 1%",
                minWidth: "5em",
                boxShadow: ({ shadows }) => shadows[1],
                borderRadius: "0.3em",
                textAlign: "center",
            },
            running
                ? {
                    backgroundColor: colors.amber["50"],
                    color: "#000",
                }
                : {},
            // running ? { backgroundColor: '#d0e0bd', color: '#000' } : {},
            calcTime < 31000 ? { backgroundColor: "#f2cccc", color: "#000" } : {},
            running && calcTime < 31000
                ? { backgroundColor: "#e69999", color: "#000" }
                : {},
        ], children: digitalClock(calcTime) }));
};
//# sourceMappingURL=Clock.js.map